'use strict';

require('../../forms/mountainRouteForm');
require('../../models/mountains/routes');

angular.module('far.modals.mountain-route-form', [
	'far.forms.mountainRouteForm',
	'far.models.mountains.routes'
])
.controller('MountainRouteFormController', function(
	$log,
	$uibModalInstance,
	mountainRouteForm,
	mountainRoutes,
	selectedPeak
) {
	var vm = {
		mountainRouteModel: mountainRouteForm,
		mountainRoute: mountainRoutes.new({
			mountain_peaks: [undefined],
			slides_files: [],
			documents_files: []
		}),
		submit: submit,
		getDocumentUrl: getDocumentUrl,
		close: function() {
			$uibModalInstance.dismiss();
		}
	};

	vm.mountainRouteModel.$fields.description.options.class = 'form__item';
	vm.mountainRouteModel.$fields.mountain_peak.uiSelectOptions.onSelect = function(item, model, options) {
		if (item) { vm.mountainRoute.mountain_peaks[options.index] = item; }
	};
	vm.mountainRouteModel.$fields.routeType.options.class = 'form__item form__item_select width-200 margin_r_20';
	vm.mountainRouteModel.$fields.routeComplexity.options.class = 'form__item form__item_select width-200 margin_r_20';
	vm.mountainRouteModel.$fields.routeUser.options.class = 'form__ui-select width-340';
	vm.mountainRouteModel.$fields.routeUser.uiSelectOptions.onSelect = function (item) {
		if (item) { vm.mountainRoute.user = item; }
	};
	vm.mountainRouteModel.$fields.documentsFiles.uploader.removeFromQueue = function (value) {
		var index = this.getIndexOfItem(value);
		var item = this.queue[index];

		if (item.isUploading) {
			item.cancel();
		} else {
			vm.documents_files.splice(index, 1);
		}

		this.queue.splice(index, 1);
		item._destroy();

		this.progress = this._getTotalProgress();
	};

	if (selectedPeak) {
		vm.mountainRoute.mountain_peaks[0] = selectedPeak;
	}

	function getDocumentUrl(file_id) {
		return Routing.generate('api_upload_get_file', {fileStorage: file_id});
	}

	function submit() {
		vm.mountainRoute.documents_files = vm.mountainRoute.documents_files.concat(
			vm.documents_files
				.filter(function(document) {
					return document.isUploaded;
				})
				.map(function(document) {
					return document.serverData;
				})
		);
		vm.mountainRouteModel.$fields.documentsFiles.uploader.clearQueue();

		vm.mountainRoute.slides_files = vm.mountainRoute.slides_files.map(function(slide, index) {
			slide.sort = index + 1;
			return slide;
		});

		vm.mountainRoute.save()
			.then(function(response) {
				$uibModalInstance.close(response.data);
			})
			.catch(function (response) {
				$log.error(response);
			});
	}

	return vm;
});